// Custom @font-face declarations for Open Sans (latin subset, weights 400–800).
// Uses font-display:optional instead of Fontsource's default font-display:swap
// so the browser never performs a late font swap that would cause layout shift.
// Same woff2 binaries from @fontsource/open-sans; only the display descriptor changes.
require("./src/components/fonts.css")
// Bootstrap JS and Popper.js removed — navbar collapse and dropdowns are now
// managed via React state in navbar.js, eliminating ~150 KB from the app bundle.


// AnyMind360 script is now injected via gatsby-ssr.js onRenderBody so the
// browser starts fetching it during HTML parsing rather than after hydration.

exports.onRouteUpdate = () => {
  // Code to execute on page load
  if (window.anymindTS != null) window.startAnymindTS()
  //window.alert("open")
}

exports.onPreRouteUpdate = () => {
  // Code to execute when the page transitions to another page
  if (window.anymindTS?.dispose) window.anymindTS.dispose()
}
